<template lang="pug">
  v-container.fill-height(style="max-height: 100%;")
    v-card(min-height="100%" min-width="100%")
      //- Taxes dialog
      v-dialog(v-model='showtaxesDialog' :fullscreen="isMobile" scrollable='' max-width='400px')
        taxes-dialog(@Close="showtaxesDialog=false")
      //- Print QR
      v-dialog(persistent v-if="isPrinting && model.qrcode" :value='isPrinting'  max-width='800px' :fullscreen='isMobile' transition="dialog-bottom-transition")
        print-qr-code(@endPrint="isPrinting = false" :image="model.qrcode")
      //- Show QR
      v-dialog( persistent  v-model="showqrcode"  max-width='500px'   transition="dialog-bottom-transition")
        v-card()
          v-card-title.dialog-card-title
            p Codigo QR
            v-icon(color="white" aria-label="Close" @click='closeQrModal') mdi-close
          v-card-text(id="qrcode" style='max-width: 230px; margin: auto;')
            v-img(v-if="model.qrcode" :src="model.qrcode")
          .text-center
            v-btn(@click='closeQrModal') Cancelar
            v-btn(color='#008e95' @click="print()")
              | Imprimir
      //- Content
      //- Title
      v-card-title.dialog-card-title
        v-row.mx-3
          p Crear producto
          dots.ml-1(:length="model.type !== 'ingredient' ? 4 : 3" :activeDot="model.type === 'ingredient' && step === 4 ? step-1:step")
        v-icon(color="white" aria-label="Close" @click="$emit('close'); refresh()") mdi-close
      //- Content
      v-card-text.text-center.px-3
        v-row
          v-col(cols="12" md="12")
            v-snackbar(v-model='snackbar',  color="red" center top  :timeout="6000")
              | {{ message }}
              v-btn(dark='', text='', @click='snackbar = false')
                | Cerrar
            //- Create category
            v-dialog( persistent  :value='createCategoryDialog'  max-width='500px'   transition="dialog-bottom-transition")
              create-category( @close="createCategoryDialog=false")
            v-form
              v-container(v-if="!field.locations.length")
                h2 Parece que no has creado tu primera tienda
                p Solo puedes crear productos si tienes al menos una tienda disponible
                v-btn.my-3(color='primary' to="/dashboard/create-shop") crear mi primera tienda
              v-container(v-else pa-0='')
                v-card-title.title.font-weight-regular.my-0.py-0
                  span Paso {{step}} - {{ currentTitle }}
                v-window(v-model='step')
                    //- type of products
                    v-window-item(:value='1')
                      v-card-text
                          v-responsive.mx-auto(max-width="650")
                            .card__subtitle(style='text-transform:capitalize; font-weight:bold; ') ¿Qué quieres crear?
                            v-item-group.row(v-model="model.type" ).ma-auto
                              v-item(v-for="(account, i) in productTypes" :key="i" :value = 'account.value')
                                template(v-slot="{ active, toggle }")
                                  v-col.text-center(cols="6" xs="6" sm="6"  md="3").px-0
                                    v-tooltip(top="" max-width="350px")
                                      template(v-slot:activator="{ on }")
                                        v-card(:class="active ? 'card-product__card__selected' : 'transparent'" outlined @click="toggle" v-on="on").card-product__card
                                          v-card(class="grey--text" outlined).card-product__card.card-product__card__intern
                                            v-img(:src="account.icon" contain).subheading
                                          h2.text-capitalize.text--primary.product-type( style='color: #777' v-text="account.type")
                                      span {{account.tooltip}}
                    //- type of unit
                    //- v-window-item(:value='2')
                        v-card-text()
                          form
                            v-responsive.mx-auto(max-width="500")
                              .text-center.display-1.grey--text.font-weight-light.mb-6
                                | Selecciona el tipo de medida que se adapte a su producto:
                              v-item-group.row.justify-center
                                v-item(v-for="(magnitude, i) in magnitudes" :key="i")
                                  template(v-slot="{ active, toggle }")
                                    v-col.text-center(cols="6" md="4")
                                      v-tooltip(top="" max-width="350px")
                                        template(v-slot:activator="{ on }")
                                          v-card.mb-6.mx-auto.pa-2.d-inline-block.v-card--account(:class="active ? 'success--text' : 'grey--text'" outlined="" @click="setmagnitudeType(i, active)" v-on:click="toggle" v-on="on")
                                            v-icon(large="" v-text="magnitude.icon")
                                            .text-uppercase.subtitle-2.text--primary(v-text="magnitude.type")
                                        span {{magnitude.tooltip}}
                    //- Product Data
                    v-window-item(:value='2')
                      v-card-text(v-if='model.type')
                        v-row
                          v-col(cols="12" xs="12" sm="5" md="5")
                            //- Add image
                            v-col.text-center(cols="auto" style="max-height: 200px; overflow:hidden;")
                              input.d-none(ref="file" type="file" @change="handleImageUpload($event, 1)" accept="image/*")
                              v-card.pa-1.mx-auto.mt-0.d-inline-flex.v-card--account(:class="model.pictures && !model.pictures.imageInput1 ? 'background-image-container' : ''" height="180" width="180" @click="$refs.file.click()")
                                v-img(contain v-if='model.pictures && model.pictures.imageInput1' :src="model.pictures.imageInput1" height="180" width="100%")
                                v-icon.mx-auto.white--text(v-else="" size="50") mdi-camera
                            //- Add other images
                            v-col.text-center(cols="12")
                              input.d-none(ref="file2"  type="file" @change="addImageToModel($event)" accept="image/*")
                              v-btn.main-btn-grey(:disabled="imagesModel.length >= 4" small @click="$refs.file2.click()")
                                .mx-2 Imagenes alternativas
                            //- Images
                            v-col.text-center.px-1(v-for="(image, index) in imagesModel" :key="image.id" cols="auto" style="max-height: 200px; overflow:hidden;display: inline-grid;")
                              v-card.pa-1.mb-1.mx-auto.mt-0.d-inline-flex.v-card--account.success--text( outlined="" height="75" width="75" )
                                img(:id="image.id" contain style="height: 60; width: 100%; cursor: pointer;" @click="openImage($event.target)")
                                v-btn(style=" position: absolute; top: -20px; right: -20px;" text icon color="red")
                                  v-icon.font-weight-bold(dark @click="deleteImageModel(index)" size="20")
                                    | mdi-close
                            //- QR
                            v-row.justify-center.mt-2(v-if="model.type != 'ingredient'")
                              v-card(color="#c0d1d5cc" height="70" width="160" elevation="0")
                                v-row
                                  v-col(cols="3")
                                    v-checkbox(v-model="model.qrcode")
                                  v-col.d-flex.justify-center.flex-column(cols="9" style="font-size: 13px; color: #8da4a9")
                                    p Generar
                                    p Código QR
                          v-col(cols="12" xs="12" sm="7" md="7")
                            //- Magnitude
                            v-select(
                              v-if="model.type === 'product'"
                              :items="magnitudes" v-model='magnitudeSelected'
                              @change="setmagnitudeType"
                              item-text="type"
                            )
                              template(v-slot:label)
                                span() Unidad
                                span.red--text() *
                            //- Name
                            v-text-field(type="text" prepend-inner-icon="mdi-tag" :rules="[rules.nameRules]" v-model='model.name' counter="100")
                              template(v-slot:label)
                                span() Nombre del producto
                                span.red--text() *
                            //- Desciption
                            v-text-field(v-if="model.type !== 'ingredient'"  prepend-inner-icon="mdi-file-document" v-model="model.description" counter="150" :rules="[rules.descriptionRules]")
                              template(v-slot:label)
                                span() Descripción
                            //- Purchase and price name
                            v-row
                              v-col(:cols="model.type === 'ingredient' ? '12':'6'" v-if='model.type !== "bundle"')
                                v-text-field(type='text' v-if='model.price' v-model='model.price.buy', prepend-inner-icon="mdi-hand-coin")
                                  template(v-slot:label)
                                    span(v-if='model.type === "service"') Inversión
                                    span(v-else) Compra
                                    span.red--text()
                              //- Sales product
                              v-col(:cols="model.type === 'bundle' ? '12':'6'" v-if='model.type !== "ingredient"')
                                v-text-field(@change="changeValTaxes" type='number' v-if='model.price && currentContext==="posts"'  v-model='model.price.salewithouttax', prepend-inner-icon="mdi-hand-coin")
                                  template(v-slot:label)
                                    span() Precio de venta genérico
                                    span.red--text() *
                                v-text-field(@change="changeValTaxes" type='number' v-else-if="model.price.salewithouttax"  v-model='model.price.salewithouttax', prepend-inner-icon="mdi-hand-coin")
                                  template(v-slot:label)
                                    span() Precio de venta genérico
                                    span.red--text() *
                                v-text-field(@change="changeValTaxes" type='number' v-else  v-model='model.price.sale', prepend-inner-icon="mdi-hand-coin")
                                  template(v-slot:label)
                                    span() Precio de venta genérico
                                    span.red--text() *
                            //- Taxes
                            v-row.my-0(v-if="model.type != 'ingredient'")
                              v-col.py-0(cols='6')
                                v-select(@change="changeValTaxes" v-model='model.taxesLstProduct', :items='lstTaxes', return-object  item-text="data.name" label='Impuestos', multiple='', small-chips='')
                              v-col.py-0.d-flex.justify-center.align-center(cols='6')
                                v-btn.main-btn-grey(small @click="showtaxesDialog = true")
                                  .mx-2
                                    v-icon mdi-plus
                                    | Crear Impuesto
                            //- Alerts
                            v-row(v-if="model.type && model.type != 'service'")
                              v-col(cols="6")
                                v-text-field.xs3(:disabled="!lowStock" label='Cantidad' v-model='model.lowStockAlert'  :rules='[rules.required, rules.twoDecimals]'  type="number")
                              v-col(cols="6")
                                v-card(color="#c0d1d5cc" height="70" width="160" elevation="0")
                                  v-row
                                    v-col.py-0(cols="3")
                                      v-checkbox( v-model="lowStock")
                                    v-col.d-flex.justify-center.flex-column(cols="9" style="font-size: 13px; color: #8da4a9")
                                      p.alert-title Alertas
                                      p Inventario bajo
                    v-window-item(:value='3')
                        v-card-text(v-if='model.type')
                          productStepper(:hideButtons = 'true' :model ='model', v-if='model.type==="product"' :field='field' :onSave='createItem' :context='currentContext' @cancel="cancel" @openCategoryModal="createCategoryDialog = true")
                          serviceStepper(:hideButtons = 'true' :model ='model', v-if='model.type==="service"' :field='field' :onSave='createItem' :context='currentContext' @cancel="cancel" @openCategoryModal="createCategoryDialog = true")
                          ingredientStepper(:hideButtons = 'true' :model ='model', v-if='model.type==="ingredient"' :field='field' :onSave='createItem' :context='currentContext' @cancel="cancel" @openCategoryModal="createCategoryDialog = true")
                          bundleStepper(:hideButtons = 'true' :model ='model', v-if='model.type==="bundle"' :field='field' :onSave='createItem' :context='currentContext' @cancel="cancel" @openCategoryModal="createCategoryDialog = true")
                    v-window-item(:value='4')
                      v-card-text(v-if='model.type')
                        v-row
                          small(style="display: block") Selecciona la(s) subcategoria(s) del producto
                          p.red--text *
                          //- Subcategoria
                          v-col.py-1(cols="12")
                            v-row
                              v-col(cols="12" xs="12" sm="6" md="6")
                                v-select(v-model='model.categories', multiple :items='field.categories', return-object  item-text='name' label='Seleccionar')
                              v-col(cols="12" xs="12" sm="4" md="4")
                                v-btn.main-btn-grey.mx-2(small width="200" @click="createCategoryDialog = true")
                                  v-icon mdi-plus
                                  | Crear Subcategoria
                          //- Tiendas
                          v-col.py-1(cols="12")
                            small.pl-2(style="display: flex") Selecciona la(s) tienda(s) del producto
                              p.red--text *
                            .text-center(style="display:flex; align-items:center;")
                              v-chip-group(v-model="model.location" column="" multiple="")
                                v-chip(filter="" outlined="" v-for="item in field.locations" :value = 'item' @click="updatePriceSaleShop({value: item})")
                                  v-avatar(left="")
                                    v-img(:src="item.pictures != undefined ? item.pictures.imageInput1 : ''")
                                  |  {{item.name}}
                          //- Impuestos
                          v-col.py-1(v-if="model.type !== 'ingredient'" cols='12' md='6')
                            v-combobox(disabled v-model="model.taxesLstProduct" :items='model.taxesLstProduct' item-text="data.name" hide-selected='' label='Impuestos' multiple='' small-chips='')
                              v-list-item
                                v-list-item-content
                                  v-list-item-title
                                    | No hay resultados encontrados similares.
                          //- Precios
                          v-col.py-1(cols="12" style="max-height: 300px; overflow-y: auto;")
                            v-flex.xs12.purchase-form__input(v-if='model.location' style='display:flex; ' v-for="(item, index) in model.location" :key="item.id" )
                              v-text-field.xs6( style='font-size: 10px;' disabled label='tienda'  type="text", v-model='item.name')
                              v-text-field.xs3(v-if='model.type !== "service" && model.type !== "bundle"' :rules="[rules.number, rules.minValue]"  type="number", v-model='item.stock')
                                template(v-slot:label)
                                  span() Cantidad
                                  span.red--text() *
                              v-text-field.xs3(v-if='model.type === "bundle"' label='Cantidad calculada' disabled  type="number", :value='getStock(item)')
                              v-text-field.xs3(v-if="model.magnitude" label="Unidad" disabled :value="model.unit")
                              v-text-field.xs3(@keyup="changeValTaxes(item)" v-if='model.type !== "ingredient"' type="number", v-model='item.pricewithouttax' prefix ='$')
                                template(v-slot:label)
                                  span() Precio de venta
                                  span.red--text() *
                                v-text-field.xs3(disabled label='Precio de venta Total' v-if='model.type !== "ingredient"' type="number", v-model='item.price' prefix ='$')
                //- v-card-actions(style='display:flex; flex-direction:row; justify-content: space-around; padding: inherit; margin: auto;')
                .text-center
                  v-btn( @click='backStep()')
                    template(v-if="step > 1")
                      label Atras
                    template(v-else='')
                      label Cancelar
                  v-btn(v-if='step < 4' :disabled='!model.type || (model.magnitude === -1 && step === 2)', color='#008e95', depressed='', @click="updatePriceSaleShop({value: 'none'})")
                    | Siguiente
                  v-btn(v-if='step === 4' :loading="loading" :disabled='invalidForm(model)', color='#008e95', depressed='', @click='createItem')
                    | Guardar
</template>
<script>
  import productStepper from '@/components/custom/steppers/ProductStepper'
  import serviceStepper from '@/components/custom/steppers/ServiceStepper'
  import ingredientStepper from '@/components/custom/steppers/IngredientStepper'
  import bundleStepper from '@/components/custom/steppers/BundleStepper'
  import CreateCategory from '@/views/custom/CreateCategory'
  import productoSimple from '@/assets/products/prod-simple-icon.png'
  import productoCompuesto from '@/assets/products/pro-comp-icon.png'
  import servicio from '@/assets/products/service-icon.png'
  import ingrediente from '@/assets/products/ingredient-icon.png'
  import Swal from 'sweetalert2'
  import * as firebase from 'firebase'
  import imageCompression from 'browser-image-compression'
  import PrintQrCode from '@/components/custom/PrintQrCode'
  let vm = null
  export default {
    components: {
      productStepper: productStepper,
      serviceStepper: serviceStepper,
      ingredientStepper: ingredientStepper,
      bundleStepper: bundleStepper,
      CreateCategory: CreateCategory,
      PrintQrCode,
      dots: () => import('@/components/custom/Dots.vue'),
      TaxesDialog: () => import('@/components/custom/dialogs/TaxesDialog'),
    },
    data: () => ({
      lowStock: false,
      message: '',
      snackbar: false,
      magnitudes: [
        {
          icon: 'mdi-numeric-1-box-multiple-outline',
          type: 'Unidad',
          tooltip: 'Si tu producto lo vendes por unidad.',
        },
        {
          icon: 'mdi-scale-balance',
          type: 'Medida',
          tooltip: 'Determina si tu producto se puede vender por peso, volumen o longitud.',
        },
      ],
      rules: {
        required: value => !!value || 'Ingresar la cantidad',
        twoDecimals: value => /^[0-9]+(\.[0-9]{1,2})?$/.test(value) || 'Maximo dos decimales',
        number: value => {
          return /^[0-9]+([,.][0-9]+)?$/g.test(value) || 'Cifra invalida.'
        },
        minValue: value => {
          return value >= 0 || 'Valor minimo debe ser igual a 0'
        },
        nameRules: value => {
          return (!!value && value.length > 0 && value.length < 101) || 'Nombre del producto debe estar entre 0 y Maximo 100 caracteres'
        },
        descriptionRules: value => {
          return value.length < 151 || 'Maximo 150 caracteres'
        },
      },
      magnitudeSelected: -1,
      loading: false,
      color: 'success',
      step: 1,
      productTypes: [
        {
          icon: productoSimple,
          type: 'Producto simple',
          value: 'product',
          tooltip: 'Cada vez que vendas un producto simple, se reducirán las cantidades de "x" producto en tu inventario',
        },
        {
          icon: productoCompuesto,
          type: 'Combos',
          value: 'bundle',
          tooltip: 'Los combos, son productos hechos a partir de ingredientes , productos simples y/o servicios, podras crear tus propios Combos ',
        },
        {
          icon: servicio,
          type: 'Servicio',
          value: 'service',
          tooltip: 'Los servicios no tendrán cantidades inventario, pero si podrás  venderlos servicio tantas veces como quieran dentro del POS y en tu tienda virtual',
        },
        {
          icon: ingrediente,
          type: 'Ingrediente',
          value: 'ingredient',
          tooltip: 'Los ingredientes no se verán reflejados dentro del POS ni dentro de tu tienda virtual, son utilizados para crear los combos, siendo parte de las recetas o combos',
        },
      ],
      timeoutTaxes: null,
      model: {
        type: 'product',
        id: null,
        name: null,
        location: [],
        stock: null,
        categories: [],
        description: '',
        ingredients: [],
        price: {
          buy: 0,
          sale: 0,
          wholesale: {
            amount: 0,
            price: 0,
            percentage: false,
            valid: true,
          },
        },
        comissionColab: {
          price: 0,
          percentage: false,
        },
        pictures: {
          imageInput1: '',
        },
        lowStockAlert: 0,
        qrcode: false,
      },
      imagesModel: [],
      currentContext: 'posts',
      createCategoryDialog: false,
      currentShopChip: '',
      theKeyOfThat: 1,
      isDragging: false,
      showqrcode: false,
      isPrinting: false,
      showtaxesDialog: false,
    }),
    computed: {
      inventory () {
        const vm = this
        if (vm.model.type === 'bundle') {
          return this.$store.getters['products/getAllItems']
        }
        return {}
      },
      currentTitle () {
        switch (this.step) {
          case 1: return 'Elije un tipo'
          case 2: return 'Elije una medida'
          case 3: return 'Detalles del producto'
          case 4: return 'Formulario de ' + this.translate(this.model.type)
          case 5: return 'Elije la categoria y tiendas'
          default: return 'Confirmacion'
        }
      },
      field () {
        return {

          locations: this.$store.getters['shops/getItems'],
          categories: this.$store.getters['categories/getItems'],
        }
      },
      user () {
        return this.$store.state.users.user
      },
      isMobile () {
        return window.innerWidth < 1024
      },
      lstTaxes () {
        console.log(this.$store.state.users.taxes)
        return this.$store.state.users.taxes
      },
    },
    watch: {
      lowStock (newValue, oldValue) {
        const vm = this
        if (vm.model.lowStockAlert && !vm.lowStock) {
          vm.model.lowStockAlert = 0
        }
      },
      'model.location': {
        // This will let Vue know to look inside the array
        deep: false,
        // We have to move our method to a handler field
        handler (newVal, oldVal) {
          const vm = this
          if (!vm.model.taxesChanged) {
            const location = newVal.find(el => el.id === vm.currentShopChip)
            location.pricewithouttax = vm.model.price.salewithouttax
            location.price = vm.model.price.sale
            vm.model.taxesChanged = false
          }
        },
      },
      async 'model.taxesLstProduct' (newVal, oldVal) {
        const vm = this
        // console.log(newVal, oldVal)
        if (newVal !== oldVal) {
          // console.log('cambio')
          vm.changeTaxesValue = await true // se agrego o elimino impuestos a el producto
          vm.model.taxesChanged = true
          for await (const loc of vm.tempLocations) {
            vm.changeValTaxesModel(loc)
          }
        }
      },
    },
    created () {
      vm = this
      vm.fetch()
      vm.$store.dispatch('users/loadTaxesLst')
      // const database = firebase.database();
      // const storage = firebase.storage();
    },
    methods: {
      /* replaceComma (item, type) {
        if (type === 'lowstock') {
          if (typeof item.lowStockAlert === 'string' && item.lowStockAlert !== '') {
            item.lowStockAlert = parseFloat(item.lowStockAlert.replace(',', '.'))
          }
          return item.lowStockAlert
        } else if (type === 'wholesale') {
          if (typeof item.price.wholesale.amount === 'string' && item.price.wholesale.amount !== '') {
            item.price.wholesale.amount = parseFloat(item.price.wholesale.amount.replace(',', '.'))
          }
          // console.log('entre', item.price.wholesale.amount)
          return item.price.wholesale.amount
        }
      }, */
      setmagnitudeType (magnitude, active) {
        const vm = this
        if (vm.magnitudeSelected === 'Unidad') {
          vm.model.magnitude = 0
        } else if (vm.magnitudeSelected === 'Medida') {
          vm.model.magnitude = 1
        } else {
          vm.model.magnitude = -1
        }
      },
      invalidForm (model) {
        const vm = this
        if (model.type === 'product') {
          let emptyStock = 0
          for (const key in model.location) {
            if (Object.prototype.hasOwnProperty.call(model.location, key)) {
              const location = model.location[key]
              if ((!location.stock && location.stock !== 0) || location.pricewithouttax === '' || !location.price) {
                emptyStock += 1
              }
            }
          }
          if (emptyStock > 0) {
            return true // disabled save button
          }
          /* console.log(emptyStock, model.magnitude, model.unit)
          console.log(`lowStock ${vm.lowStock && !model.lowStockAlert}-`, `name ${!model.name}-`, `name lengh ${model.name.length > 100}-`)
          console.log(`buy ${!model.price.buy}-`, `sale ${!model.price.sale}-`, `categories lenght ${!model.categories.length}-`, `location lengh ${!model.location.length}-`)
          console.log(`magnitude ${!!(model.magnitude && !model.unit)}-`, `description lenght ${model.description.length > 150}-`, `price ${!model.price.wholesale.valid}-`) */
          return (vm.lowStock && !model.lowStockAlert) || !model.name || model.name.length > 100 || !model.price.buy || !model.price.sale || !model.categories.length || !model.location.length || !!(model.magnitude && !model.unit) || model.description.length > 150 || !model.price.wholesale.valid /* || negativeAmounts */
        } else if (model.type === 'bundle') {
          let emptyStock = 0
          for (const key in model.ingredients) {
            if (Object.prototype.hasOwnProperty.call(model.ingredients, key)) {
              const ingredient = model.ingredients[key]
              if (!ingredient.amount) {
                emptyStock += 1
              }
            }
          }
          /* const negativeAmounts = model.ingredients.some(ingredient => {
            if (ingredient.amount < 1) {
              return true
            }
          }) */
          for (const key in model.location) {
            if (Object.prototype.hasOwnProperty.call(model.location, key)) {
              const location = model.location[key]
              if (location.pricewithouttax === '' || !location.price) {
                emptyStock += 1
              }
            }
          }
          if (emptyStock > 0) {
            return true // disabled save button
          }
          return (vm.lowStock && !model.lowStockAlert) || !model.name || model.name.length > 100 || !model.ingredients || !model.price.sale || !model.categories.length || !model.location.length || model.description.length > 150 || !model.price.wholesale.valid/*  || negativeAmounts */
        } else if (model.type === 'service') {
          let emptyPrice = 0
          for (const key in model.location) {
            if (Object.prototype.hasOwnProperty.call(model.location, key)) {
              const location = model.location[key]
              if (!location.pricewithouttax) {
                emptyPrice += 1
              }
            }
          }
          if (emptyPrice > 0) {
            return true // disabled save button
          }
          return !model.name || model.name.length > 100 || !model.price.buy || !model.price.sale || !model.categories.length || !model.location.length || model.description.length > 150 || !model.price.wholesale.valid || !model.comissionColab.valid
        } else if (model.type === 'ingredient') {
          let emptyStock = 0
          for (const key in model.location) {
            if (Object.prototype.hasOwnProperty.call(model.location, key)) {
              const location = model.location[key]
              if (!location.stock && location.stock !== 0) {
                emptyStock += 1
              }
            }
          }
          let negativeAmounts = false
          if (model.location) {
            negativeAmounts = model.location.some(item => {
              if (item.stock < 0) {
                return true
              }
            })
          }
          if (emptyStock > 0) {
            return true // disabled save button
          }
          return (vm.lowStock && !model.lowStockAlert) || !model.name || model.name.length > 100 || !model.categories.length || !model.location.length || !model.price.buy || negativeAmounts
        }
      },
      fetch () {
        const vm = this
        vm.$store.dispatch('categories/loadItems', 'categories').then(() => {})
      },
      backStep () {
        const vm = this
        if (vm.step > 1) {
          if (vm.step === 4 && vm.model.type === 'ingredient') {
            vm.step = 1
          /* } else if (vm.step === 3 && vm.model.type !== 'product') {
            vm.step = 1 */
          } else {
            vm.step--
          }
        } else {
          vm.cancel()
        }
      },
      async updatePriceSaleShop (value) {
        const vm = this
        if (value.value === 'none') {
          if (vm.model.type === 'ingredient' && vm.step === 2) {
            vm.step = 4
          } else if (vm.model.type !== 'product' && vm.step === 1) {
            vm.step = 2
          } else {
            vm.step++
          }
        } else {
          vm.currentShopChip = value.value.id
          vm.$forceUpdate()
        }
      },
      changeValTaxesModel (item) {
        const vm = this
        // console.log(vm.model.taxesLstProduct)
        // console.log(item.pricewithouttax)
        // console.log(item)
        let valTaxSum = 0
        let valTaxPercentage = 0
        if (vm.model.taxesLstProduct) {
          for (let i = 0; i < vm.model.taxesLstProduct.length; i++) {
            if (vm.model.taxesLstProduct[i].data.percentage) {
              const div = parseFloat(vm.model.taxesLstProduct[i].data.val) / 100
              const val = 1 + div
              let totVal = 0
              if (!item.pricewithouttax) {
                totVal = parseFloat(val) * parseFloat(item.price)
                valTaxPercentage = parseFloat(totVal) - parseFloat(item.price)
              } else {
                totVal = parseFloat(val) * parseFloat(item.pricewithouttax)
                valTaxPercentage = parseFloat(totVal) - parseFloat(item.pricewithouttax)
              }
            } else {
              valTaxPercentage = parseFloat(vm.model.taxesLstProduct[i].data.val)
            }
            valTaxSum = (parseFloat(valTaxSum) + parseFloat(valTaxPercentage)).toFixed(2)
          }
        }
        if (!item.pricewithouttax) {
          item.pricewithouttax = parseFloat(item.price)
        }
        item.price = (parseFloat(item.pricewithouttax) + parseFloat(valTaxSum)).toFixed(2)
        item.taxes = vm.model.taxesLstProduct
        /* for (let i = 0; i < vm.tempLocations.length; i++) {
          if (vm.tempLocations[i].id === item.id) {
            vm.tempLocations[i].price = (parseFloat(item.pricewithouttax) + parseFloat(valTaxSum)).toFixed(2)
            vm.tempLocations[i].taxes = vm.model.taxesLstProduct
          }
        } */
        vm.$forceUpdate()
      },
      changeValTaxes () {
        // console.log(this.model.taxesLstProduct)
        const vm = this
        vm.tempLocations = Object.values(vm.model.location) || []
        let valTaxSum = 0
        let valTaxPercentage = 0
        if (vm.model.taxesLstProduct) {
          for (let i = 0; i < vm.model.taxesLstProduct.length; i++) {
            if (vm.model.taxesLstProduct[i].data.percentage) {
              const div = parseFloat(vm.model.taxesLstProduct[i].data.val) / 100
              // console.log('div', div)
              const val = 1 + div
              let totVal = 0
              if (!vm.model.price.salewithouttax) {
                totVal = parseFloat(val) * parseFloat(vm.model.price.sale)
                valTaxPercentage = parseFloat(totVal) - parseFloat(vm.model.price.sale)
              } else {
                totVal = parseFloat(val) * parseFloat(vm.model.price.salewithouttax)
                valTaxPercentage = parseFloat(totVal) - parseFloat(vm.model.price.salewithouttax)
              }
            } else {
              valTaxPercentage = parseFloat(vm.model.taxesLstProduct[i].data.val)
            }
            valTaxSum = (parseFloat(valTaxSum) + parseFloat(valTaxPercentage)).toFixed(2)
          }
        }
        if (!vm.model.price.salewithouttax) {
          // console.log('crear sale without')
          // vm.model.price.sale = (parseFloat(vm.model.price.salewithouttax) + parseFloat(valTaxSum)).toFixed(2)
          vm.model.price.salewithouttax = parseFloat(vm.model.price.sale)
        }
        vm.model.price.sale = (parseFloat(vm.model.price.salewithouttax) + parseFloat(valTaxSum)).toFixed(2)
        // console.log(vm.model.price)
        if (!vm.changeTaxesValueComputed) {
          // console.log('hola')
          for (let i = 0; i < vm.tempLocations.length; i++) {
            vm.tempLocations[i].pricewithouttax = vm.model.price.salewithouttax
            vm.tempLocations[i].price = vm.model.price.sale
          }
        }
      },
      getStock (location) {
        const vm = this
        // let stock = 0;
        const ingredients = vm.model.ingredients
        const quantities = []

        ingredients.forEach(function (el) {
          const currentItem = vm.inventory.find(item => item.id === el.id)
          if (currentItem) {
            try {
              if (currentItem.location[location.id]) { quantities.push(Math.floor(currentItem.location[location.id].stock / el.amount)) } else quantities.push(0)
            } catch (err) {
              quantities.push(0)
            }
          } else quantities.push(0)
        })

        return Math.min(...quantities) || 0
      },
      translate (name) {
        switch (name) {
          case 'product':
            return 'producto'
          case 'service':
            return 'servicio'
          case 'bundle':
            return 'Combo'
          case 'ingredient':
            return 'ingrediente'
        }
      },
      createItem: async function () {
        // A post entry.
        const vm = this
        vm.loading = true
        const itemData = vm.model || {}
        const filteredLocation = {}
        if (itemData.type === 'ingredient') {
          delete itemData.ingredients
          // delete price y agregar solo cost?
        }
        // console.log(itemData)
        let valid = true
        if (!Array.isArray(itemData.categories)) {
          itemData.categories = [{
            ...itemData.categories,
          }]
        }
        // console.log(itemData.categories)
        await itemData.location.forEach(function (el) {
          // console.log(el)
          if (el.price) {
            filteredLocation[el.id] = {
              id: el.id,
              image: el.image || '',
              name: el.name,
              price: el.price,
              taxes: el.taxes ? el.taxes : [],
              pricewithouttax: el.pricewithouttax,
              stock: itemData.type === 'service' || itemData.type === 'bundle' ? 0 : el.stock,
              kitchenAprobal: el.kitchenAprobal || false,
            }
          } else {
            if (itemData.type === 'ingredient') {
              filteredLocation[el.id] = {
                id: el.id,
                image: el.image || '',
                name: el.name,
                price: 0,
                stock: el.stock,
              }
            } else {
              // console.log(el)
              valid = false
              vm.loading = false
            }
          }
        })
        itemData.location = filteredLocation
        // this.$store.commit('setLoading', true);
        // this.$forceUpdate()
        await vm.imagesModel.forEach(async (image, index) => {
          await vm.handleImageUpload(image, index + 2, true)
        })
        // console.log(itemData)
        setTimeout(function () {
          if (valid) {
            this.$store.dispatch('products/createItem', itemData).then((res) => {
              vm.loading = false
              vm.model = res
              vm.onSuccess()
            })
          }
        }.bind(this), 3000)
      },
      refresh () {
        const vm = this
        vm.field.locations.forEach(item => { item.stock = 0 })
        vm.model = {
          uid: null,
          name: null,
          location: [],
          stock: null,
          categories: [],
          ingredients: null,
          price: {
            buy: null,
            sale: null,
          },
          pictures: {
            imageInput1: '',
          },
        }
        vm.$forceUpdate()
      },
      onSuccess () {
        const vm = this
        Swal.fire({
          icon: 'success',
          title: 'Producto creado con exito',
        }).then(() => {
          // console.log(vm.model)
          if (vm.model.qrcode) {
            vm.showqrcode = true
          } else {
            vm.refresh()
            vm.$emit('close')
          }
        })
      },
      closeQrModal () {
        const vm = this
        vm.showqrcode = false
        vm.refresh()
        vm.$emit('close')
      },
      cancel () {
        this.refresh()
        this.$emit('close')
      },
      setImage (image) {
        vm.model.imagen = image
        // // console.log(vm.model.imagen);
      },
      async addImageToModel (event, isDragAndDrop = false) {
        const vm = this
        let file
        if (!isDragAndDrop) {
          file = event.target.files[0]
        } else {
          file = event
        }
        // console.log(file)
        if (!file) return
        if (file.type.includes('image')) {
          if (vm.imagesModel.length < 4) {
            await vm.imagesModel.push({ id: Math.random(), image: file })
          } else {
            await vm.imagesModel.splice(vm.imagesModel.length - 1, 1, file)
          }
          const reader = new FileReader()
          reader.onload = await async function () {
            const output = await document.getElementById(vm.imagesModel[vm.imagesModel.length - 1].id)
            // console.log(output)
            output.src = await reader.result
            // console.log(file)
          }
          await reader.readAsDataURL(file)
        } else {
          vm.message = 'El archivo subido no es una imagen'
          vm.snackbar = true
        }
      },
      deleteImageModel (index) {
        const vm = this
        vm.imagesModel.splice(index, 1)
      },
      async handleImageUpload (event, numberFile, alt = false) {
        const vm = this
        let imageFile
        if (alt) {
          imageFile = event.image
        } else {
          imageFile = event.target.files[0]
        }
        if (!imageFile) return
        if (imageFile.type.includes('image')) {
          // console.log('originalFile instanceof Blob', imageFile instanceof Blob) // true
          // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`)

          const options = {
            maxSizeMB: 0.06,
            maxWidthOrHeight: 200,
            useWebWorker: true,
            maxIteration: 14,
          }
          try {
            const compressedFile = await imageCompression(imageFile, options)
            // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob) // true
            // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`) // smaller than maxSizeMB
            if (imageFile.size > compressedFile.size) {
              // console.log('compressed is smaller')
              await vm.uploadToServer(compressedFile, numberFile)
            } else {
              // console.log('original is smaller')
              await vm.uploadToServer(imageFile, numberFile)
            } // if original is smaller
          } catch (error) {
            // console.log(error)
          }
        } else {
          vm.message = 'El archivo subido no es una imagen'
          vm.snackbar = true
        }
      },
      uploadToServer (file, numberFile) {
        const vm = this
        const storageRef = firebase.storage().ref()
        let userId
        if (vm.user.adminUid) {
          userId = vm.user.adminUid
        } else {
          userId = vm.user.uid
        }
        vm.model.id = vm.model.id ? vm.model.id : firebase.database().ref().child(`users/${userId}/inventory`).push().key
        const metadata = {
          contentType: file.type,

          customMetadata: {
            targetType: file.type,
            targetId: vm.model.id,
            targetName: vm.model.name,
          },
        }
        // Push to child path.
        // [START oncomplete]
        storageRef.child(`users/${userId}/inventory/pictures/${vm.model.id}/imageInput${numberFile}`).put(file, metadata).then(function (snapshot) {
          snapshot.ref.getDownloadURL().then(function (url) {
            if (numberFile === 1) {
              vm.model.pictures.imageInput1 = url
            } else if (numberFile === 2) {
              vm.model.pictures.imageInput2 = url
            } else if (numberFile === 3) {
              vm.model.pictures.imageInput3 = url
            } else if (numberFile === 4) {
              vm.model.pictures.imageInput4 = url
            } else if (numberFile === 5) {
              vm.model.pictures.imageInput5 = url
            }
          })
        }).catch(function (error) {
          console.error('Upload failed:', error)
        })
      },
      dragover (event) {
        event.preventDefault()
        const vm = this
        vm.isDragging = true
      },
      dragleave (event) {
        const vm = this
        vm.isDragging = false
      },
      async drop (event) {
        const vm = this
        event.preventDefault()
        if (vm.imagesModel.length < 4) {
          for await (const element of event.dataTransfer.files) {
            // console.log(element)
            await vm.addImageToModel(element, true)
          }
        }
        vm.isDragging = false
      },
      openImage (img) {
        Swal.fire({
          imageUrl: img.src,
          imageWidth: 400,
          imageHeight: 400,
          imageAlt: 'Product alternative image',
        })
      },
      print () {
        /* const vm = this
        const win = window.open('about:blank', '_new')
        win.document.open()
        win.document.write([
          '<html>',
          '   <head>',
          '   </head>',
          '   <body onload="window.print()" onafterprint="window.close()" onbeforeunload ="">',
          '       <img src="' + vm.model.qrcode + '"/>',
          '   </body>',
          '</html>',
        ].join(''))
        win.document.close() */
        /* const vm = this
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
        WinPrint.document.write([
          '<html>',
          '   <head>',
          '   </head>',
          '   <body onload="window.print()" onafterprint="window.close()" onbeforeunload ="">',
          '       <img src="' + vm.model.qrcode + '"/>',
          '   </body>',
          '</html>',
        ].join(''))
        WinPrint.document.close()
        WinPrint.setTimeout(function () {
          WinPrint.focus()
          WinPrint.print()
          WinPrint.close()
        }, 500) */
        const vm = this
        vm.isPrinting = true
      },
    },
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .background-image-container{
      background: #9eb2b6;
    }
    .ql-video {
        max-width: 100%;

    }
    img{
        max-width: 100%;
        height:auto;
    }

    .card {
      &__title {
        background: rgb(45,180,188);
        background: linear-gradient(90deg, rgba(45,180,188,1) 0%, rgba(87,101,190,1) 100%);
        color: white;
        font-weight: 800;
        border-radius: 5px;
        text-transform: uppercase;
      }

      &__subtitle {
        font-weight: 500;
        text-transform: uppercase;
        font-weight: 300;
        color: #525252;
        border-bottom: 1px solid #95dadd;
        display: inline-block;
      }

      &-product__card {
        height: 10rem;
        width: 13rem;
        padding: 12px;
        display: inline-block;
        border-width: 4px;
        border-radius: 25px;
        .product-type{
          font-size: 12px !important;
          line-height: 12px;
          color: rgba(#777, 0.7);
        }
        .subheading{
          max-height: 100%;
          img {
            object-fit: contain;
          }
          .v-image__image--cover{
            background-size: contain;
          }
        }
        @media (min-width: 1080px) {
          height: 13rem;
          width: 13rem;
          margin-bottom: 24px;
          &__intern {
          height: 10rem;
          }
          .product-type{
            font-size: 20px !important;
            line-height: 20px;
          }
        }

        &__intern {
          max-height: 6rem;
          width: 8rem;
          overflow:hidden;
        }

        &__selected {
          border-color: #2cb6bc;
        }
      }
    }
</style>
